import logo from './logo.svg';
import './styles.css';
/* Components */
import Navbar from './components/Navbar';
import Footer from './components/Footer';
/* Pages */
import Portfolio from './pages/Portfolio';
import About from './pages/About';
import ProjectShowcase from './pages/ProjectShowcase';
/* Router Module */
import { Route, Routes } from 'react-router-dom'

function App() {
  return (
    <body className="bg-black text-primary w-full min-h-screen">
      <div className="m-8">

        <Navbar />

        <Routes>
          <Route path="/" element={<Portfolio />} />
          {/* <route path="/" element={<Cinematography />} /> */}
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/project/:id" element={<ProjectShowcase />} />
          <Route path="/about" element={<About />} />
          {/* <route path="/contact" element={<Contact />} /> */}
        </Routes>

        <Footer />

      </div>
    </body>
  );
}

export default App;
